import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, HostListener, Input, Output, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DarkModeService } from '../dark-mode.service';
import { TokenService } from '../../services/token.service';
import { MyMonitoringService } from '../../services/logging.service';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';
const GRAPH_ENDPOINT_GET_EMPLOYEEID = 'https://graph.microsoft.com/v1.0/me?$select=employeeId';

type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string,
  displayName?: string,
  jobTitle?: string,
  officeLocation?: string
}


@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [ReactiveFormsModule, RouterModule, CommonModule, FormsModule, ButtonModule, AvatarModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None

})


export class HeaderComponent {
  isDarkMode: boolean = false;
  userDetails: any;
  searchValue: string = '';
  userName: any;
  profilePhtotoUrl = environment.profilePhtotoUrl;
  Title: string = environment.appTitle;
  profile!: ProfileType;
  @Input() isSearchVisible: boolean = true;
  @Input() isNotificationVisible: boolean = true;
  @Input() isThemeVisible: boolean = true;
  isMobileView: boolean = false;
  @Input() isSidebarOpen: boolean = false; // Receive the state from the parent
  @Output() toggleSidebarEvent = new EventEmitter<void>(); // Emit event to parent
  @Input() productName: string = environment.appTitle;
  searchControl: FormControl = new FormControl('');
  notificationCount: number = 11;
  userGivenname: string = '';
  userSurName: string = '';


  constructor(
    private http: HttpClient,
    private darkModeService: DarkModeService,
    private token: TokenService,
    private monotoringService: MyMonitoringService,) {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isMobileView = window.innerWidth < 768;
  }

  ngOnInit() {
    this.getProfile();
    this.darkModeService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode = isDarkMode;
    });
    this.searchControl.valueChanges.subscribe((value: string) => {
      this.onSearch(value);
    });
  }

  onToggleSidebar() {
    this.toggleSidebarEvent.emit();
  }
  onSearch(value: string): void {
  }

  toggleDarkMode(): void {
    this.darkModeService.toggleDarkMode();
  }

  getProfile() {
    this.http.get(GRAPH_ENDPOINT)
      .subscribe((profile: ProfileType) => {
        this.profile = profile;
        sessionStorage.setItem("useremail", this.profile.userPrincipalName ? this.profile.userPrincipalName : '');
        this.http.get(GRAPH_ENDPOINT_GET_EMPLOYEEID)
          .subscribe((data: any) => {
            sessionStorage.setItem("userId", data.employeeId ? data.employeeId : 0)
          });
        this.userGivenname = this.profile.givenName ? this.profile.givenName : ''
        this.userSurName = this.profile.surname ? this.profile.surname : ''
        sessionStorage.setItem("userName", this.userGivenname + ', ' + this.userSurName)
      });
  }

  toggleSearch() {
    this.isSearchVisible = !this.isSearchVisible;
  }

  clearSearch() {
    this.searchValue = '';
    this.isSearchVisible = !this.isSearchVisible;
  }
}